import { localStorage } from 'dibs-browser-storage';
import { graphql } from 'react-relay';

import { getLocalRecentHistoryList } from './getLocalRecentHistory';
import {
    MAX_RECENTLY_VIEWED_ITEMS,
    RECENT_HISTORY_COUNT,
    RECENT_HISTORY_LIST,
} from './recentHistoryConstants';

// types
import { addLocalRecentHistory_item as RecentHistoryItemType } from './__generated__/addLocalRecentHistory_item.graphql';
import { LocalHistoryItemType } from './recentHistoryTypes';

export const addLocalRecentHistoryItem = ({
    contemporaryTrackingString,
    firstPhotoWebPath,
    pdpURL,
    title,
    browseUrl,
    categoryCode,
    serviceId,
    categoryPath,
    seller,
    isComplete,
    isListingListed,
}: RecentHistoryItemType): void => {
    /**
     * Add only available items to local storage.
     */
    if (isComplete && isListingListed) {
        const currentDate = new Date();
        const currentItem: LocalHistoryItemType = {
            contemporaryTrackingString,
            itemTitle: title || document.title,
            itemId: serviceId || '',
            itemImageUrl: firstPhotoWebPath || '',
            itemPdpUrl: pdpURL || '',
            itemBrowseUrl: browseUrl,
            itemCategoryCode: categoryCode,
            dealerPk: seller?.serviceId || '',
            category: categoryPath,
            timestamp: currentDate.getTime().toString(),
        };

        const localRecentHistoryList =
            getLocalRecentHistoryList(currentItem, MAX_RECENTLY_VIEWED_ITEMS) || [];

        localRecentHistoryList.push(currentItem);

        localStorage.setItem(RECENT_HISTORY_COUNT, localRecentHistoryList.length);
        localStorage.setItem(RECENT_HISTORY_LIST, JSON.stringify(localRecentHistoryList));
    }
};

export const itemFragment = {
    item: graphql`
        fragment addLocalRecentHistory_item on Item {
            contemporaryTrackingString
            firstPhotoWebPath(size: small)
            pdpURL
            title
            browseUrl
            categoryCode
            serviceId
            categoryPath
            seller {
                serviceId
            }
            isComplete
            isListingListed
        }
    `,
};
